import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './SubjectSelector.css';

function SubjectSelector() {
  const navigate = useNavigate();
  const { grade } = useParams();

  const subjects = [
    {
      id: 'vocabulary',
      name: 'אוצר מילים',
      icon: '📚',
      description: 'משחקים לתרגול מילים בערבית',
      color: '#4CAF50'
    },
    {
      id: 'verbs',
      name: 'הפועל',
      icon: '🧩',
      description: 'משחקי נטיית הפועל בערבית',
      color: '#2196F3'
    },
    {
      id: 'syntax',
      name: 'תחביר',
      icon: '📝',
      description: 'תרגול חוקי מבנה המשפט',
      color: '#FF9800'
    },
    {
      id: 'spoken',
      name: 'מדוברת',
      icon: '🗣️',
      description: 'תרגול הערבית המדוברת',
      color: '#E91E63'
    },
  ];

  const gradeNames = {
    'grade10': 'שכבה י׳',
    'grade11': 'שכבה י״א',
    'grade12': 'שכבה י״ב'
  };

  const handleSubjectClick = (subjectId) => {
    if (subjectId === 'vocabulary') {
      navigate(`/grade/${grade}/${subjectId}`);
    } else if (subjectId === 'verbs') {
      navigate(`/grade/${grade}/verbs`);
    } else {
      alert('הנושא הזה עדיין בפיתוח 😊');
    }
  };

  const handleBackToGrades = () => {
    navigate('/');
  };

  return (
    <div className="subject-selector">
      <div className="subject-selector-container">
        <div className="header-with-back">
          <button onClick={handleBackToGrades} className="back-to-grade-button" style={{ top: '-32px' }}>
   חזרה לבחירת שכבה ↩          
          </button>
          <h2>{gradeNames[grade]}</h2>
        </div>

        <p className="subject-selector-subtitle">בחר את הנושא שברצונך ללמוד</p>

        <div className="subjects-grid">
          {subjects.map((subject) => (
            <div
              key={subject.id}
              className="subject-card"
              onClick={() => handleSubjectClick(subject.id)}
              style={{ '--subject-color': subject.color }}
            >
              <div className="subject-icon">{subject.icon}</div>
              <h3 className="subject-name">{subject.name}</h3>
              <p className="subject-description">{subject.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SubjectSelector;